import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import $ from 'jquery';

import Rest from 'services/data/rest';

// Components
import PageHeader from './page-header';

// Actions
import * as Filter from 'modules/filters/store/actions';
import { clearAlerts } from 'modules/alerts/actions';


// Exports
export default class Page extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
    title: PropTypes.string
  };

  /**
   * Removes filters, deregisters the url change listener, and
   * resets all resources when the user leaves the page. This prevents
   * flashes of out-of-date content when arriving at the next page.
   */
  componentWillUnmount() {
    Filter.removeFilters();
    clearAlerts();
    Rest.cancelAllCancellableRequests();
  }

  render() {
    const { className, children, title, ...props } = this.props;
    const height = $(window).height();
    const width = $(window).width();
    const style = width < 850 ? { height } : {};

    return (
      <div {...props} className={classNames(className, 'page')} style={style}>
        { title &&
          <PageHeader>
            <h1>{title}</h1>
          </PageHeader>
        }
        {children}
      </div>
    );
  }
}
